export const initialState = () => ({
  answerSelected: null,
  name: null,
  contact: null,
  cpf: null,
  existReminder: false,
  reminder: null,
  postcode: "",
  street: null,
  number: null,
  complement: null,
  location: {
    longitude: null,
    latitude: null
  },
  note: "",
  reasonSelected: null,
  indicative: {
    show: false,
    text: "",
    isInRoute: false
  }
})
